<template>
    <div class="register">
        <div class="form form--wechat--choose">
            <div class="club_logo">
                <img src="https://resource.rcclchina.com.cn/login/club_logo.png" alt="">
            </div>
            <div class="form--register__top"></div>
            <div class="form--register__logo">
                <img src="https://resource.rcclchina.com.cn/login/logo.jpg" alt="">
            </div>
            
            <h3>您的微信未绑定皇家加勒比账号</h3>
            <p>请选择绑定已有账号,或者创建新账号</p>
            <div class="wechat--choose--buttons">
                <div class="button wechatBind_btn">
                    <button class="wechat--choose__button button--orange" @click="goToLogin">我有皇家加勒比账号，登录绑定</button>
                </div>
                <div class="button wechatReg_btn">
                    <button class="wechat--choose__button button--purple" @click="goToLogin">>创建新账号</button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "WechatBind",
    methods: {
        goToLogin () {
            this.$router.push({name: "WechatLogin", query: { returnUrl: this.returnUrl }})
        }
    },
    computed: {
        returnUrl () {
            return this.$router.currentRoute.query.returnUrl || ""
        }
    }
}
</script>

<style lang="less" scoped>
/* GLOBAL STYLES
-------------------------------------------------- */
.button--purple {
  color: #fff;
  background-color: #0C1856; }

/* Padding below the footer and lighter body text */
/* RESPONSIVE CSS
------------------------------------------------------------------------------------------------- */
/* common */
.register {
  display: flex;
  align-items: center;
  height: 880px;
  width: 100%;
  flex-direction: column;
  background-image: url(https://resource.rcclchina.com.cn/login/register_bg.jpg);
  background-size: cover; }

.register_vip {
  display: flex;
  align-items: center;
  height: 1085px;
  width: 100%;
  flex-direction: column;
  background: #F0F0F0;
  background-size: cover;
  background-image: url(https://resource.rcclchina.com.cn/login/register_bg.jpg);
}

.club_logo {
  position: absolute;
  top: -80px;
  left: 15px; }

.form--register {
  position: relative;
  max-width: 560px;
  width: 100%;
  margin-top: 100px;
  border-radius: 3px;
  box-shadow: 0px 1px 50px rgba(0, 0, 0, 0.5);
  background-color: #fff;
  padding-bottom: 20px; }
  .form--register__top {
    height: 5px;
    background: #031257;
    border-radius: 5px; }
  .form--register__logo {
    position: relative;
    margin-top: 40px;
    text-align: center; }
  .form--register h3 {
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    color: #031257; }
  .form--register .rccl--form {
    width: 284px;
    margin: auto;
    margin-top: 40px; }
    .form--register .rccl--form input {
      font-style: normal;
      height: 36px; }
  .form--register .input--register {
    position: relative;
    margin-bottom: 15px; }
    .form--register .input--register a {
      font-size: 12px;
      color: blue; }
    .form--register .input--register .eyeIcon, .form--register .input--register .eyeIconR {
      position: absolute;
      position: absolute;
      top: 7px;
      right: 15px;
      cursor: pointer; }
  .form--register .input--veriCode {
    width: 174px;
    display: inline-block; }
  .form--register .button__sendVeri {
    width: 90px;
    margin-left: 1px;
    padding: 7px 5px;
    display: inline-block;
    border-radius: 3px; 
    float:right;
  }
  .form--register .button {
    margin-top: 35px;
    text-align: center; }
  .form--register__button {
    text-align: center;
    font-size: 16px;
    border-radius: 25px;
    padding: 16px 110px; }
  .form--register__link,.form--skip__link {
    text-align: center;
    font-size: 16px;
    margin-top: 15px; }

#code {
  font-style: italic;
  font-weight: bold;
  border: 0;
  letter-spacing: 2px;
  color: blue; }

/* wechat choose */
.wechat_choose {
  display: flex;
  align-items: center;
  height: 780px;
  width: 100%;
  flex-direction: column;
  background: #F0F0F0;
  background-size: cover; }

.form--wechat--choose {
  position: relative;
  max-width: 560px;
  width: 100%;
  margin-top: 100px;
  border-radius: 3px;
  box-shadow: 0px 1px 50px rgba(0, 0, 0, 0.5);
  background-color: #fff;
  padding-bottom: 100px;
  text-align: center; }

  .form--wechat--choose h3 {
    margin-top: 80px;
    font-size: 24px;
    font-weight: bold;
    color: #202020; }
    .form--wechat--choose h2 {
    margin-top: 80px;
    font-size: 24px;
    font-weight: bold;
    color: #202020; }
  .form--wechat--choose p {
    margin-top: 20px;
    font-size: 16px;
    color: #202020; }
  .form--wechat--choose .wechat--choose--buttons {
    margin-top: 60px; }
    .form--wechat--choose .wechat--choose--buttons .button--orange {
      color: #031257;
    }
    .form--wechat--choose .wechat--choose--buttons .button--orange a{
      color:black;
    }

  .form--wechat--choose .wechat--choose__button {
    width: 300px;
    margin-top: 20px;
    padding: 16px 0px;
    text-align: center;
    font-size: 16px;
    border-radius: 25px; }

/**** ����ͬ���İ�20170802  ****/
#isAgree {
    width:14px;
    height:14px;
    display:inline-block;
    vertical-align:top;
}
.privacyLink {
    text-decoration:none;
}
.privacyLink:hover{
    text-decoration:none;
}

.addInfo_birthCalendar{
    top:30px;
    left:0;
}
.addInfo_birthCalendar.calendar .calendar--title .title .title__year
,.calendar .calendar--title .title .title__month{
    display:inline-block;
    vertical-align:middle;
}
.addInfo_birthCalendar.calendar .calendar--title .title {
    text-align:center;
}

/*------------- common -------------*/
/* pc
------------------------------------------------------------------------------------------------------- */
/*-------------pc--------------*/
/* RESPONSIVE CSS
------------------------------------------------------------------------------------------------- */
/* tablet */
/* RESPONSIVE CSS
------------------------------------------------------------------------------------------------- */
/* tablet */

/*# sourceMappingURL=register.css.map */

</style>